export default __webpack_public_path__ + "static/media/family-gathering-desktop@2x.7a423eff.jpg";